import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { LiveSessionIconSvgComponent } from '../svg-sprites/general/live-session-icon-svg.component';
import { LessonsDBService } from '../services/lessons-db.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'live-session-bar',
  imports: [LiveSessionIconSvgComponent],
  templateUrl: './live-session-bar.component.html',
  styleUrl: './live-session-bar.component.scss'
})
export class LiveSessionBarComponent implements OnInit, OnDestroy {
  private lessonsDB = inject(LessonsDBService);
  private router = inject(Router);
  
  isBannerVisible = false;
  currentLiveSession: any = null;
  private subscription?: Subscription;

  ngOnInit() {
    this.loadLiveSessions();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  loadLiveSessions() {
    this.subscription = this.lessonsDB.loadAllLiveSessions().subscribe({
      next: (sessions) => {
        const now = new Date();
        
        // Find sessions that are live RIGHT NOW
        const liveSessions = sessions.filter(session => {
          const sessionData = session.liveSession || session.webinar;
          if (!sessionData?.sessionDate) return false;

          const sessionDate = sessionData.sessionDate.toDate();
          const durationHours = sessionData.sessionDuration?.hours || 1;
          const durationMinutes = sessionData.sessionDuration?.minutes || 0;
          const sessionEnd = new Date(sessionDate);
          sessionEnd.setHours(sessionEnd.getHours() + durationHours);
          sessionEnd.setMinutes(sessionEnd.getMinutes() + durationMinutes);

          return now >= sessionDate && now <= sessionEnd;
        });

        if (liveSessions.length > 0) {
          this.currentLiveSession = liveSessions[0];
          this.isBannerVisible = true;
        } else {
          this.isBannerVisible = false;
        }
      }
    });
  }

  joinLiveSession() {
    if (this.currentLiveSession) {
      this.router.navigate([
        '/courses', 
        this.currentLiveSession.courseUrl, 
        this.currentLiveSession.sectionSeqNo || 1, 
        'lessons', 
        this.currentLiveSession.seqNo
      ]);
    }
  }

  closeLiveSolutionBanner() {
    this.isBannerVisible = false;
  }
}
